export enum GiveStages {
  Proposed = 'Proposed',
  Approved = 'Approved',
  FinancialHold = 'Financial Hold',
  Completed = 'Completed',
}
